import React from 'react';
import './Button.css';
import {Link} from 'react-router-dom';



const Styles = ['btn--primary', 'btn--outline'];

const Size = ['btn--medium', 'btn--large'];


function Button({children, onClick, type, buttonStyle, buttonSize}) {
  const checkButtonStyle = Styles.includes(buttonStyle) ? buttonStyle : Styles[0];
  const checkButtonSize =  Size.includes(buttonSize) ? buttonSize : Size[0];

    return (
        <Link to='/Appointment' className='btn-mobile'>
            <button
            className={`btn ${checkButtonSize} ${checkButtonStyle}`}
            onClick={onClick}
            type={type}
            
            >
                {children}
            </button>
        </Link>
    )

}

export default Button